import React from 'react';
import styled from 'styled-components';

const AlertPill = ({ severity = 'info', status = 'open' }) => (
    <Wrap>
        <Chip $kind={severity}>{severity}</Chip>
        <Chip $kind={status}>{status}</Chip>
    </Wrap>
);

export default AlertPill;

const Wrap = styled.div`
    display: inline-flex;
    gap: 0.375rem;
    flex-wrap: wrap;
`;

const Chip = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 0.1875rem 0.5rem;
    border-radius: 999px;
    font-size: 0.6875rem;
    font-weight: 600;
    text-transform: capitalize;
    background: ${({ theme, $kind }) =>
        ($kind === 'warning' || $kind === 'open') ? (theme.colors.warningBg || '#fffbeb') :
        ($kind === 'danger' || $kind === 'failed') ? (theme.colors.dangerBg || '#fef2f2') :
        ($kind === 'resolved' || $kind === 'success') ? (theme.colors.successBg || '#ecfdf5') :
        (theme.colors.infoBg || '#eff6ff')};
    color: ${({ theme, $kind }) =>
        ($kind === 'warning' || $kind === 'open') ? (theme.colors.warning || '#ffc107') :
        ($kind === 'danger' || $kind === 'failed') ? (theme.colors.danger || '#dc3545') :
        ($kind === 'resolved' || $kind === 'success') ? (theme.colors.success || '#28a745') :
        (theme.colors.info || '#17a2b8')};
`;

